/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "FWi5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./style.css
var style = __webpack_require__("FWi5");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ../node_modules/throttle-debounce/dist/index.esm.js
/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
function throttle(delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */

  function wrapper() {
    var self = this;
    var elapsed = Date.now() - lastExec;
    var args = arguments;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, args);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */

    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

/* eslint-disable no-undefined */
/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}  [atBegin]     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @return {Function} A new, debounced function.
 */

function debounce(delay, atBegin, callback) {
  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
}


// CONCATENATED MODULE: ./app.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var placeholderImage = "/assets/songsearch-autocomplete-static/placeholder.png";
var lazyloadThumbnailImage = "/assets/songsearch-autocomplete-static/lazyload-thumbnail.png";

// XXX MAKE THIS CONFIGURABLE
var SERVER = "https://songsear.ch";

function absolutifyUrl(uri) {
  if (uri.charAt(0) === "/" && uri.charAt(1) !== "/") {
    return SERVER + uri;
  }
  return uri;
}

// https://coderwall.com/p/i817wa/one-line-function-to-detect-mobile-devices-with-javascript
function isMobileDevice() {
  return typeof window.orientation !== "undefined" || navigator.userAgent.indexOf("IEMobile") !== -1;
}

var app_App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      q: _this.props.initialValue || "",
      autocompleteSuggestions: null,
      autocompleteHighlight: -1,
      showAutocompleteSuggestions: true,
      redirectingSearch: false,
      searchMaxLength: null
    }, _this.submitSearch = function (event) {
      event.preventDefault();
      _this._submit(_this.state.q);
    }, _this._submit = function () {
      var submitevent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "enter";
      var q = _this.state.q;

      if (!q.trim()) {
        return;
      }

      // XXX Perhaps this extra "?autocomplete=${...}" is obsolete!
      var gotoURL = SERVER + "/q/" + encodeURIComponent(q) + "?autocomplete=" + submitevent;
      _this.setState({
        redirectingSearch: true,
        autocompleteSuggestions: null,
        autocompleteHighlight: -1,
        showAutocompleteSuggestions: true
      }, function () {
        setTimeout(function () {
          if (!_this.dismounted) {
            _this.setState({ redirectingSearch: false });
          }
        }, 3000);
        document.location.href = gotoURL;
      });
    }, _this.onFocusSearch = function () {
      if (!_this.state.showAutocompleteSuggestions) {
        _this.setState({
          showAutocompleteSuggestions: true,
          redirectingSearch: false
        });
      }

      if (!_this._firstFocusSearch) {
        _this._firstFocusSearch = true;
        // If you're on a small screen this is the first time you've focused,
        // the scroll the top of the search input into view.
        if (window.innerHeight && window.innerHeight < 600) {
          _this.qRef.scrollIntoView();
        }
      }
    }, _this.onBlurSearch = function () {
      setTimeout(function () {
        _this.setState({
          showAutocompleteSuggestions: false
        });
      }, 300);
    }, _this.onChangeSearch = function (event) {
      var q = event.target.value;
      _this.setState({ q: q }, function () {
        var _this$state = _this.state,
            q = _this$state.q,
            searchMaxLength = _this$state.searchMaxLength;

        var length = q.length;
        var maxLength = _this.qRef.maxLength;

        if (length > maxLength - 10) {
          _this.setState({
            searchMaxLength: [length, maxLength],
            showAutocompleteSuggestions: false
          });
        } else if (searchMaxLength) {
          _this.setState({
            searchMaxLength: null,
            showAutocompleteSuggestions: true
          });
        }

        if (q.trim()) {
          if (_this.waitingFor) {
            if (q.trim() === _this.waitingFor.trim()) {
              // Don't bother, only whitespace has changed.
              return;
            }
          }
          if ((length < 4 || q.endsWith(" ")) && length < 24) {
            // The impatient one.
            _this.fetchAutocompleteSuggestionsThrottled(q);
          } else if (length > 24) {
            // The patient one.
            _this.fetchAutocompleteSuggestionsDebouncedLong(q);
          } else if (length) {
            // The patient one.
            _this.fetchAutocompleteSuggestionsDebounced(q);
          } else {
            _this.setState({
              autocompleteSuggestions: null,
              autocompleteSearchSuggestions: null,
              autocompleteHighlight: -1,
              showAutocompleteSuggestions: true,
              redirectingSearch: false
            });
          }
        } else {
          _this.setState({
            autocompleteSuggestions: null,
            autocompleteSearchSuggestions: null,
            autocompleteHighlight: -1,
            showAutocompleteSuggestions: true,
            redirectingSearch: false
          });
        }
      });
    }, _this.fetchAutocompleteSuggestions = function (q) {
      var url = SERVER + "/api/search/autocomplete?q=" + encodeURIComponent(q);
      var cached = _this._fetchAutocompleteSuggestionsCache[q.trim()];
      if (cached) {
        return Promise.resolve(cached).then(function (results) {
          _this.setState({
            autocompleteSuggestions: results.matches,
            autocompleteSearchSuggestions: results.search_suggestions,
            autocompleteHighlight: -1
          });
        });
      }
      _this.waitingFor = q;
      fetch(url).then(function (r) {
        if (r.status === 200) {
          if (q.startsWith(_this.waitingFor)) {
            r.json().then(function (results) {
              _this._fetchAutocompleteSuggestionsCache[q.trim()] = results;
              _this.setState({
                autocompleteSuggestions: results.matches,
                autocompleteSearchSuggestions: results.search_suggestions,
                autocompleteHighlight: -1
              });
            });
          }
        }
      }).catch(function (ex) {
        console.warn("Catch fetching " + url + " ('" + q + "'): " + ex.toString());
      });
    }, _this.fetchAutocompleteSuggestionsDebounced = debounce(800, _this.fetchAutocompleteSuggestions), _this.fetchAutocompleteSuggestionsDebouncedLong = debounce(1800, _this.fetchAutocompleteSuggestions), _this.fetchAutocompleteSuggestionsThrottled = throttle(1100, _this.fetchAutocompleteSuggestions), _this._fetchAutocompleteSuggestionsCache = {}, _this.onKeyDownSearch = function (event) {
      var suggestions = _this.state.autocompleteSuggestions;
      if (suggestions) {
        var highlight = _this.state.autocompleteHighlight;
        if ((event.key === "ArrowDown" || event.key === "Tab") && highlight < suggestions.length) {
          event.preventDefault();
          _this.setState({ autocompleteHighlight: highlight + 1 });
        } else if (event.key === "ArrowUp" && highlight > -1) {
          _this.setState({ autocompleteHighlight: highlight - 1 });
        } else if (event.key === "Enter") {
          if (highlight > -1) {
            event.preventDefault();
            var searchSuggestions = _this.state.autocompleteSearchSuggestions;
            if (highlight === 0 && searchSuggestions && searchSuggestions.total) {
              _this._submit("search");
              return;
            }
            highlight--;
            if (suggestions[highlight]._url) {
              _this.setState({
                redirectingSearch: true,
                autocompleteSuggestions: null,
                autocompleteHighlight: -1
              }, function () {
                setTimeout(function () {
                  if (!_this.dismounted) {
                    _this.setState({ redirectingSearch: false });
                  }
                }, 3000);
                document.location.href = absolutifyUrl(suggestions[highlight]._url);
              });
            } else {
              _this.setState({
                q: suggestions[highlight].text,
                autocompleteSuggestions: null,
                autocompleteHighlight: -1
              }, function () {
                return _this._submit();
              });
            }
          }
        }
      }
    }, _this.onSelectSuggestion = function (event, suggestion) {
      event.preventDefault();
      if (suggestion._url) {
        _this.setState({
          redirectingSearch: true,
          autocompleteSuggestions: null,
          autocompleteHighlight: -1
        }, function () {
          document.location.href = absolutifyUrl(suggestion._url);
        });
        return;
      }
      var newText = suggestion.text;
      _this.setState({
        q: newText,
        autocompleteSuggestions: null,
        autocompleteHighlight: -1
      }, function () {
        _this._submit("clicked");
      });
    }, _this.onSelectSuggestionAll = function (event) {
      event.preventDefault();
      _this._submit("search");
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  App.prototype.componentDidMount = function componentDidMount() {
    // If the <input> HTML had something typed into it when the React
    // app started, that would be passed to the App when initialized.
    // For example if the React app is slow to load. I.e. async slow.
    var q = this.state.q;

    if (q) {
      this.fetchAutocompleteSuggestions(q);
    }
    if (!isMobileDevice() && !document.location.hash) {
      this.qRef.focus();
    }
  };

  App.prototype.componentWillUnmount = function componentWillUnmount() {
    this.dismounted = true;
  };

  App.prototype.render = function render() {
    var _this2 = this;

    return Object(preact_min["h"])(
      "form",
      {
        style: { margin: "50px 0" },
        action: SERVER + "/q/",
        onSubmit: this.submitSearch
      },
      Object(preact_min["h"])(
        "div",
        { className: "ui icon input fluid", style: { display: "relative" } },
        Object(preact_min["h"])("input", {
          type: "search",
          name: "term",
          ref: function ref(r) {
            return _this2.qRef = r;
          },
          maxLength: 150,
          value: this.state.q,
          onFocus: this.onFocusSearch,
          onBlur: this.onBlurSearch,
          onInput: this.onChangeSearch,
          onKeyDown: this.onKeyDownSearch,
          className: "form-control x-large",
          placeholder: "Type your lyrics search here...",
          "aria-label": "Lyrics search"
        }),
        Object(preact_min["h"])("i", { className: "search icon", onClick: this.onSelectSuggestionAll }),
        this.state.autocompleteSuggestions && this.state.autocompleteSuggestions.length && this.state.showAutocompleteSuggestions ? Object(preact_min["h"])(app_ShowAutocompleteSuggestions, {
          q: this.state.q,
          onSelectSuggestionAll: this.onSelectSuggestionAll,
          onSelectSuggestion: this.onSelectSuggestion,
          highlight: this.state.autocompleteHighlight,
          suggestions: this.state.autocompleteSuggestions,
          searchSuggestions: this.state.autocompleteSearchSuggestions
        }) : null
      ),
      this.state.searchMaxLength ? Object(preact_min["h"])(ShowMaxlengthWarning, {
        length: this.state.searchMaxLength[0],
        maxLength: this.state.searchMaxLength[1]
      }) : null,
      this.state.redirectingSearch ? Object(preact_min["h"])(
        "p",
        null,
        "Sending search to",
        " ",
        Object(preact_min["h"])(
          "a",
          { href: SERVER + "/q/" + encodeURIComponent(this.state.q) },
          "SongSearch"
        ),
        " ",
        "now..."
      ) : null
    );
  };

  return App;
}(preact_min["Component"]);




function ShowMaxlengthWarning(_ref) {
  var length = _ref.length,
      maxLength = _ref.maxLength;

  var className = "help-block maxlength";
  if (length === maxLength) {
    className += " danger";
  }
  return Object(preact_min["h"])(
    "p",
    { className: className },
    length,
    " of max ",
    maxLength,
    " characters!"
  );
}

// XXX this used to be React.memo() wrapped
var app_ShowAutocompleteSuggestions = function ShowAutocompleteSuggestions(_ref2) {
  var q = _ref2.q,
      highlight = _ref2.highlight,
      suggestions = _ref2.suggestions,
      searchSuggestions = _ref2.searchSuggestions,
      onSelectSuggestion = _ref2.onSelectSuggestion,
      onSelectSuggestionAll = _ref2.onSelectSuggestionAll;

  return Object(preact_min["h"])(
    "div",
    { className: "autocomplete" },
    Object(preact_min["h"])(
      "ul",
      null,
      searchSuggestions ? Object(preact_min["h"])(
        "li",
        {
          onClick: onSelectSuggestionAll,
          className: highlight === 0 ? "active search-suggestion" : "search-suggestion"
        },
        Object(preact_min["h"])(
          "p",
          null,
          searchSuggestions.capped ? Object(preact_min["h"])(
            "a",
            {
              className: "total",
              href: "/q/" + encodeURIComponent(searchSuggestions.term)
            },
            searchSuggestions.total.toLocaleString(),
            " ",
            searchSuggestions.desperate ? "approximate matches" : "good matches"
          ) : null,
          Object(preact_min["h"])(
            "a",
            { href: "/q/" + encodeURIComponent(searchSuggestions.term) },
            "Search for ",
            Object(preact_min["h"])(
              "b",
              null,
              q
            )
          )
        )
      ) : null,
      suggestions.map(function (s, index) {
        var className = index + 1 === highlight ? "active" : null;
        return Object(preact_min["h"])(
          "li",
          {
            key: s.id || s.text,
            className: className,
            onClick: function onClick(e) {
              return onSelectSuggestion(e, s);
            }
          },
          s.id ? Object(preact_min["h"])(app_ShowAutocompleteSuggestionSong, { song: s }) : Object(preact_min["h"])("p", {
            className: "simple-autocomplete",
            dangerouslySetInnerHTML: { __html: s.html }
          })
        );
      })
    )
  );
};

// XXX this used to be React.memo() wrapped

var _ref4 = Object(preact_min["h"])(
  "span",
  { className: "by" },
  " by "
);

var app_ShowAutocompleteSuggestionSong = function ShowAutocompleteSuggestionSong(_ref3) {
  var song = _ref3.song;

  var imageUrl = placeholderImage;
  if (song.image) {
    if (song.image.thumbnail100) {
      imageUrl = absolutifyUrl(song.image.thumbnail100);
    } else if (song.image.url) {
      imageUrl = absolutifyUrl(song.image.url);
    }
  }
  return Object(preact_min["h"])(
    "div",
    { className: "media autocomplete-suggestion-song" },
    Object(preact_min["h"])(
      "div",
      { className: "media-left" },
      Object(preact_min["h"])(app_SongImage, { url: imageUrl, name: song.name })
    ),
    Object(preact_min["h"])(
      "div",
      { className: "media-body" },
      Object(preact_min["h"])(
        "h5",
        { className: "artist-name" },
        Object(preact_min["h"])(
          "b",
          null,
          song.name
        ),
        _ref4,
        Object(preact_min["h"])(
          "span",
          null,
          song.artist.name
        )
      ),
      song.fragments.map(function (fragment, i) {
        return Object(preact_min["h"])("p", { key: i, dangerouslySetInnerHTML: { __html: fragment } });
      })
    )
  );
};

var loadedOnce = new Set();

new Image().src = lazyloadThumbnailImage;

var app_SongImage = function (_Component2) {
  _inherits(SongImage, _Component2);

  function SongImage() {
    var _temp2, _this3, _ret2;

    _classCallCheck(this, SongImage);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this3), _this3.state = { loaded: false }, _this3.imageLoadCallback = function () {
      if (!_this3.dismounted) {
        _this3.setState({ loaded: true }, function () {
          loadedOnce.add(_this3.props.url);
        });
      }
    }, _this3.effect = function () {
      var src = _this3.getCurrentSrc();
      var url = _this3.props.url;


      if (src === lazyloadThumbnailImage) {
        // We need to preload the eventually needed image.
        _this3.preloadImg = new Image();

        // const self = this;
        // function cb() {
        //   if (!self.dismounted) {
        //     self.setState({ loaded: true }, () => {
        //       loadedOnce.add(url);
        //     });
        //   }
        // }
        // This must come before .decode() otherwise Safari will
        // raise an EncodingError.
        _this3.preloadImg.src = url;
        // https://html.spec.whatwg.org/multipage/embedded-content.html#dom-img-decode
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/decode#Browser_compatibility
        _this3.preloadImg.decode ? _this3.preloadImg.decode().then(_this3.imageLoadCallback, _this3.imageLoadCallback) : _this3.preloadImg.onload = _this3.imageLoadCallback;
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/decoding
        // XXX Why 'sync' and not 'async'??
        _this3.preloadImg.decoding = "sync";
      }
    }, _this3.getCurrentSrc = function () {
      var url = _this3.props.url;
      var loaded = _this3.state.loaded;

      if (url) {
        // There is hope! The song has an image.
        if (loadedOnce.has(url) || loaded) {
          return url;
        }
        return lazyloadThumbnailImage;
      }
      return placeholderImage;
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  SongImage.prototype.componentDidMount = function componentDidMount() {
    this.effect();
  };

  SongImage.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.preloadImg) {
      // See https://jsfiddle.net/nw34gLgt/ for demo of this technique.
      // Immediately undo the preloading since we might not need this image.
      this.preloadImg.src = "";
    }
    this.dismounted = true;
  };

  SongImage.prototype.render = function render(_ref5) {
    var name = _ref5.name;

    return Object(preact_min["h"])("img", {
      className: "img-rounded",
      src: this.getCurrentSrc(),
      alt: name,
      title: name
    });
  };

  return SongImage;
}(preact_min["Component"]);
// CONCATENATED MODULE: ./index.js





var root = document.getElementById('root');
var index_form = root.querySelector('form');
var initialValue = '';
var initialInput = index_form.querySelector('input[name="term"]');
if (initialInput) {
  initialValue = initialInput.value;
}
Object(preact_min["render"])(Object(preact_min["h"])(app_App, { initialValue: initialValue }), root, index_form);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    null != e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.d91f9.js